/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EventConfigResponse { 
    event_type?: string;
    event_sub_type?: string;
    level?: string;
    tenant_ui?: boolean;
}

